<template>
  <div v-if="isVisible" class="popup-overlay" @click.self="closePopup">
    <div class="popup-container">
      <!-- 분양문의 (상단) -->
      <div class="popup-contact">
        <p class="contact-label">분양문의</p>
        <div class="contact-numbers">
          <a href="tel:1800-1088" class="phone-number main">1800-1088</a>
        </div>
      </div>

      <!-- 팝업 이미지 -->
      <div class="popup-image">
        <img src="@/assets/mainpopup.png" alt="분양안내" />
      </div>

      <!-- 관심고객등록 버튼 -->
      <button class="register-btn" @click="openRegistration">
        <span class="btn-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
            <path d="M9 12l2 2 4-4"/>
            <circle cx="12" cy="12" r="10"/>
          </svg>
        </span>
        <span class="btn-text">지금 바로 관심고객등록하기</span>
        <span class="btn-arrow">→</span>
      </button>

      <!-- 하단 버튼들 -->
      <div class="popup-actions">
        <button class="action-btn hide-24h" @click="hideFor24Hours">
          24시간 동안 보지 않기
        </button>
        <button class="action-btn close" @click="closePopup">
          닫기
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MainPopup',
  emits: ['open-form'],
  data() {
    return {
      isVisible: false
    }
  },
  mounted() {
    this.checkVisibility()
  },
  methods: {
    checkVisibility() {
      const hideUntil = localStorage.getItem('mainPopupHideUntil')
      if (hideUntil) {
        const hideUntilTime = parseInt(hideUntil, 10)
        if (Date.now() < hideUntilTime) {
          this.isVisible = false
          return
        }
      }
      this.isVisible = true
    },
    closePopup() {
      this.isVisible = false
    },
    hideFor24Hours() {
      const hideUntil = Date.now() + (24 * 60 * 60 * 1000)
      localStorage.setItem('mainPopupHideUntil', hideUntil.toString())
      this.isVisible = false
    },
    openRegistration() {
      this.$emit('open-form')
      this.isVisible = false
    }
  }
}
</script>

<style scoped>
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  z-index: 10000;
}

.popup-container {
  background: #fff;
  overflow: hidden;
  max-width: 420px;
  width: 100%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
  animation: popupIn 0.3s ease;
}

@keyframes popupIn {
  from {
    opacity: 0;
    transform: scale(0.95) translateY(10px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

/* 분양문의 (상단) */
.popup-contact {
  padding: 16px 20px;
  text-align: center;
  background: #222;
}

.contact-label {
  font-size: 11px;
  color: #999;
  margin-bottom: 6px;
  letter-spacing: 1px;
}

.contact-numbers {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.phone-number {
  font-size: 22px;
  font-weight: 700;
  color: #fff;
  text-decoration: none;
  transition: color 0.2s;
}

.phone-number.main {
  color: #D4AF37;
  font-size: 24px;
}

.phone-number:hover {
  color: #E5C158;
}

.divider {
  color: #555;
  font-size: 20px;
}

/* 이미지 */
.popup-image {
  width: 100%;
  line-height: 0;
}

.popup-image img {
  width: 100%;
  height: auto;
  display: block;
}

/* 관심고객등록 버튼 - 강조 */
.register-btn {
  width: 100%;
  padding: 22px 24px;
  background: linear-gradient(135deg, #C9302C 0%, #A12622 100%);
  color: #fff;
  border: none;
  font-size: 18px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  transition: all 0.3s;
  position: relative;
  overflow: hidden;
}

.register-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
  animation: shimmer 2s infinite;
}

@keyframes shimmer {
  0% { left: -100%; }
  100% { left: 100%; }
}

.register-btn:hover {
  background: linear-gradient(135deg, #D9403C 0%, #B12E2A 100%);
  transform: scale(1.02);
}

.register-btn:active {
  transform: scale(0.98);
}

.btn-icon {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-icon svg {
  width: 100%;
  height: 100%;
}

.btn-text {
  letter-spacing: 0.5px;
}

.btn-arrow {
  font-size: 20px;
  animation: arrowPulse 1s ease-in-out infinite;
}

@keyframes arrowPulse {
  0%, 100% { transform: translateX(0); opacity: 1; }
  50% { transform: translateX(5px); opacity: 0.7; }
}

/* 하단 버튼들 */
.popup-actions {
  display: flex;
  border-top: 1px solid #e5e5e5;
}

.action-btn {
  flex: 1;
  padding: 14px;
  background: #f8f8f8;
  border: none;
  font-size: 13px;
  color: #888;
  cursor: pointer;
  transition: all 0.2s;
}

.action-btn:first-child {
  border-right: 1px solid #e5e5e5;
}

.action-btn:hover {
  background: #eee;
  color: #555;
}

.action-btn.close {
  font-weight: 600;
  color: #666;
}

/* 반응형 */
@media (max-width: 480px) {
  .popup-container {
    max-width: 340px;
  }

  .popup-contact {
    padding: 14px 16px;
  }

  .phone-number {
    font-size: 18px;
  }

  .phone-number.main {
    font-size: 20px;
  }

  .divider {
    font-size: 16px;
  }

  .register-btn {
    padding: 18px 20px;
    font-size: 16px;
  }

  .action-btn {
    padding: 12px;
    font-size: 12px;
  }
}
</style>
